import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
import "../../css/TelefonosNotificacion.css";


function TelefonosNotificacion() {
  const cookies = new Cookies();

  const baseURL = process.env.REACT_APP_API_BASE_URL + "/api/Chat";
  //const baseURL = "https://localhost:7126/api/Chat";


  const [numeroInteresado, setNumeroInteresado] = useState([]);
  const [numeroSpam, setNumeroSpam] = useState([]);
  const [numeroFueraTema, setNumeroFueraTema] = useState(false);
  const [userName, setUserName] = useState("");
  const [perfil, setRol] = useState("");

  const [form, setForm] = useState({
    numeroInteresado: "",
    numeroSpam: "",
    numeroFueraTema: "",
    numeroPersonalHumano: "",
    usuMod: userName,
  });

  const [formNumerosNot, setFormNumerosNot] = useState({
    numeroInteresado: "",
    numeroSpam: "",
    numeroFueraTema: "",
    numeroPersonalHumano: ""
  });

    
  

  ///Validar campos obligatorios
  const validarCampos = () => {
    const camposObligatorios = [
      { campo: "numeroInteresado", label: "Número Para Notificar Interesado en Tarjeta" },
      { campo: "numeroSpam", label: "Tipo de Número Para Notificar SPAM" },
      { campo: "numeroFueraTema", label: "Número Para Notificar Mensaje Fuera de Tema" },
      { campo: "numeroPersonalHumano", label: "Número para notificación en caso de requerir asesor" }
    ];

    console.log("Campos obligatorios validados");

    for (const { campo, label } of camposObligatorios) {
      if (!form[campo] || form[campo].trim() === "") {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          title: `El campo "${label}" es obligatorio`,
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return false;
      }
    }

    return true;  // ← ¡ESTE FALTABA!
  };


  //Guardar los datos del formulario
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //Al iniciar el formulario, load
  useEffect(() => {
    setUserName(cookies.get("nombreUsuario") || "");
    setRol(cookies.get("perfil") || "");

    // 1. Cargar datos actuales
    axios
      .get(baseURL + `/ObtenerNumerosParaNotificacion`)
      .then((response) => {
        const { data } = response.data; // ← lista de teléfonos

        //SI no hay data salir
        if (!Array.isArray(data)) return;

        // Ordenar los números según tipo
        let interesado = data.find((x) => x.tipoNotificacion === "INTERESADO CURSO");
        let spam = data.find((x) => x.tipoNotificacion === "SPAM");
        let fueraTema = data.find((x) => x.tipoNotificacion === "FUERA DE TEMA");
        let reqAsesor = data.find((x) => x.tipoNotificacion === "REQUIERE ASESOR");

        setForm({
          numeroInteresado: interesado?.numeroTelefono || "",
          numeroSpam: spam?.numeroTelefono || "",
          numeroFueraTema: fueraTema?.numeroTelefono || "",
          numeroPersonalHumano: reqAsesor?.numeroTelefono || "",
          usuMod: cookies.get("nombreUsuario") || ""
        });

      })
      .catch((error) => {
        console.error("Error al consultar números:", error);

        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Error al consultar los números",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      });
  }, []);

  if (perfil && perfil !== "Administrador") return <Navigate to="/inicio" />;


  //Function para guardar los numeros
  const guardarNumero = async (tipo, numero) => {
    try {
      const payload = {
        numeroTelefono: "57" + numero,
        tipoNotificacion: tipo,
        usuarioModificacion: userName
      };

      const response = await axios.post(
        baseURL + "/ActualizarTelefonoNotificacion",
        payload
      );

      return true;

    } catch (error) {
      console.error("Error al actualizar:", error);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "No se pudo actualizar el teléfono",
        showConfirmButton: false,
        timer: 3000
      });

      return false;
    }
  };

  //Metodo encargado de actulizar los numeros
  const actualizarDatos = async () => {
    if (!validarCampos()) return;

    const ok1 = await guardarNumero("INTERESADO CURSO", form.numeroInteresado);
    const ok2 = await guardarNumero("SPAM", form.numeroSpam);
    const ok3 = await guardarNumero("FUERA DE TEMA", form.numeroFueraTema);
    const ok4 = await guardarNumero("REQUIERE ASESOR", form.numeroPersonalHumano);

    if (ok1 && ok2 && ok3 && ok4) {
      Swal.fire({
        icon: "success",
        title: "Teléfonos actualizados correctamente",
        showConfirmButton: false,
        timer: 2000
      });
    }
  };


  //HTML
  return (
    <div className="telefonos-container">
      <div className="telefonos-card">
        <div className="card-header-custom d-flex align-items-center">
          <h3 className="card-title-custom">
            <i className="fas fa-address-book mr-2"></i>
            Números de Teléfono Para Notificación
          </h3>
        </div>

        <div className="form-section">
          <div className="row">

           {/* Interesado
            <div className="col-md-6">
              <div className="custom-form-group">
                <label className="custom-label">
                  Interesado en Curso <span className="text-danger">*</span>
                </label>
                <div className="custom-input-group">
                  <div className="custom-prepend">
                    <span>+57</span>
                  </div>

                  <input
                    type="text"
                    name="numeroInteresado"
                    value={form.numeroInteresado}
                    onChange={handleInputChange}
                    maxLength={10}
                    className="custom-input"
                    placeholder="Número (10 dígitos)"
                  />
                </div>
              </div>
            </div>*/}

            {/* SPAM */}
            <div className="col-md-4">
              <div className="custom-form-group">
                <label className="custom-label">
                  Número SPAM <span className="text-danger">*</span>
                </label>

                <div className="custom-input-group">
                  <div className="custom-prepend">
                    <span>+57</span>
                  </div>

                  <input
                    type="text"
                    name="numeroSpam"
                    value={form.numeroSpam}
                    onChange={handleInputChange}
                    maxLength={10}
                    className="custom-input"
                    placeholder="Número (10 dígitos)"
                  />
                </div>
              </div>
            </div>

            {/* Fuera de tema */}
            <div className="col-md-4">
              <div className="custom-form-group">
                <label className="custom-label">
                  Mensaje Fuera de Tema <span className="text-danger">*</span>
                </label>

                <div className="custom-input-group">
                  <div className="custom-prepend">
                    <span>+57</span>
                  </div>

                  <input
                    type="text"
                    name="numeroFueraTema"
                    value={form.numeroFueraTema}
                    onChange={handleInputChange}
                    maxLength={10}
                    className="custom-input"
                    placeholder="Número (10 dígitos)"
                  />
                </div>
              </div>
            </div>

            {/* Solicita Asesor Humano */}
            <div className="col-md-4">
              <div className="custom-form-group">
                <label className="custom-label">
                  Número para notificación en caso de requerir asesor <span className="text-danger">*</span>
                </label>

                <div className="custom-input-group">
                  <div className="custom-prepend">
                    <span>+57</span>
                  </div>

                  <input
                    type="text"
                    name="numeroPersonalHumano"
                    value={form.numeroPersonalHumano}
                    onChange={handleInputChange}
                    maxLength={10}
                    className="custom-input"
                    placeholder="Número (10 dígitos)"
                  />
                </div>
              </div>
            </div>

          </div>

          <div className="action-area">
            <button
              className="btn-save-custom text-white"
              onClick={actualizarDatos}
            >
              <i className="fas fa-save"></i>
              Guardar Cambios
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TelefonosNotificacion;
